import React from 'react';
import axios, {AxiosHeaders} from 'axios';
import {loginWithToken} from '../action/auth'
import {connect} from "react-redux";
import {Navigate} from "react-router-dom";
import axiosHandler from "../services/https";

const Authorize = ({ loginWithToken, isAuthenticated, isOperator, error }) => {

	// redirect just-in-case (or to end the flow)
	if (isAuthenticated || error) {
		if (isOperator) {
			return <Navigate to='/invalidate' />
		} else {
			return <Navigate to='/' />
		}
	}

	const params = new URLSearchParams(window.location.href);
	const code = params.get('code');
	const postParams = new URLSearchParams();
	postParams.append('grant_type', 'authorization_code');
	postParams.append('code', code);
	let redirectUri = document.location.origin + process.env.REACT_APP_KEYCLOAK_REDIRECT_URI;
	postParams.append('redirect_uri',redirectUri);
	const config = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	};
	axiosHandler.getInstance().post(
		`${process.env.REACT_APP_API_URL}/store/token`,
		postParams,config)
	.then((response) => {
		console.log(response);
		loginWithToken(response);
	})
	.catch(err => {
		console.log(err);
	});
}

const mapStateToProps = state => ({
	isAuthenticated: state.auth.isAuthenticated,
	error:state.auth.error,
	isOperator: state.auth.isOperator
});


export default connect(mapStateToProps, { loginWithToken })(Authorize);
